import { useTranslation } from 'react-i18next'

import { QA_NAME_CLOSE_BTN } from '../../../constants/qa'
import Button from '../../Button'

import CloseIcon from '../../../icons/close.svg'

function ModalCloseButton({ onClose, ...restProps }) {
  const { t } = useTranslation()

  return (
    <Button.Text
      {...restProps}
      isGrey
      beforeIconProps={{ Icon: CloseIcon }}
      qaName={QA_NAME_CLOSE_BTN}
      tooltip={t('Modal.CloseTooltipKey')}
      onClick={onClose}
    />
  )
}

export default ModalCloseButton
